import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import './ReversoPisoSpcPremium.css';

window.$ = window.jQuery = $;

require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel/dist/assets/owl.theme.default.css');
require('owl.carousel');

const ReversoPisoSpcPremium = () => {
  const [carouselInitialized, setCarouselInitialized] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const $carousel = $('.reverso-carousel');

      if ($carousel.length && !carouselInitialized) {
        try {
          $carousel.owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            smartSpeed: 700,
            responsive: {
              0: { items: 1, dots: true },
              768: { items: 1, dots: true },
              1024: { items: 1, dots: true },
            },
          });
          setCarouselInitialized(true);
        } catch (error) {
          console.error('Error initializing carousel:', error);
        }
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      try {
        const $carousel = $('.reverso-carousel');
        if ($carousel.length && carouselInitialized) {
          $carousel.trigger('destroy.owl.carousel');
          setCarouselInitialized(false);
        }
      } catch (error) {
        console.error('Error destroying carousel:', error);
      }
    };
  }, [carouselInitialized]);

  return (
    <section className="reverso-piso-section py-5 py-lg-7">
      <div className="container">

        {/* ── BLOQUE 1: Reverso / Backing ── */}
        <div className="row align-items-center reverso-block mb-5 mb-lg-7">

          {/* Columna Carrusel */}
          <div className="col-lg-6 mb-4 mb-lg-0 order-1 order-lg-1">
            <div className="reverso-carousel-wrapper wow fadeInLeft" data-wow-delay="200ms">
              <div className="reverso-carousel owl-carousel owl-theme">
                <div className="item">
                  <img
                    src="/assets/img/productos/pisos-spc-premium/BACKIN/img1.jpg"
                    alt="Reverso Piso SPC Premium - Vista 1"
                  />
                </div>
                <div className="item">
                  <img
                    src="/assets/img/productos/pisos-spc-premium/BACKIN/img2.jpg"
                    alt="Reverso Piso SPC Premium - Vista 2"
                  />
                </div>
                <div className="item">
                  <img
                    src="/assets/img/productos/pisos-spc-premium/BACKIN/img3.jpg"
                    alt="Reverso Piso SPC Premium - Vista 3"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Columna Texto Backing */}
          <div className="col-lg-6 order-2 order-lg-2">
            <div className="reverso-content ps-lg-4 wow fadeInRight" data-wow-delay="300ms">
              <div className="mb-3 title-style5">
                <h2 className="h1 font-weight-800 mb-0">
                  Revés del Piso SPC
                </h2>
              </div>

              <p className="mb-4 opacity9 fs-18">
                Cada panel incluye un bajo alfombra integrado (backing), una capa acolchada adherida al núcleo que eleva el confort, el aislamiento y el silencio sin necesidad de instalar una manta adicional.
              </p>

              <div className="reverso-benefits">
                <div className="benefit-item mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-shoe-prints"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Confort al caminar</h4>
                      <p className="mb-0 opacity7">
                        La espuma amortigua cada paso, reduciendo la fatiga
                        en espacios de uso cotidiano.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="benefit-item mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-temperature-half"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Aislamiento térmico</h4>
                      <p className="mb-0 opacity7">
                        Actúa como barrera contra el frío del contrapiso,
                        manteniendo una temperatura más agradable en el ambiente.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-volume-xmark"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Reducción de ruido</h4>
                      <p className="mb-0 opacity7">
                        Absorbe el impacto acústico de los pasos, ideal para
                        departamentos, oficinas y espacios de alto tráfico.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Divisor visual ── */}
        <div className="reverso-divider my-5 my-lg-6"></div>

        {/* ── BLOQUE 2: Sistema Unilin Click ── */}
        <div className="row align-items-center unilin-block">

          {/* Columna Texto Unilin — izquierda en desktop, arriba en móvil */}
          <div className="col-lg-6 mb-4 mb-lg-0 order-1 order-lg-2">
            <div className="unilin-image-wrapper wow fadeInRight" data-wow-delay="200ms">
              {/* Reemplaza este placeholder con la ruta real de tu imagen */}
              <img
                src="/assets/img/productos/pisos-spc-premium/unilin-click.jpg"
                alt="Sistema de ensamblado Unilin Click - Piso SPC Premium"
                className="unilin-img"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              {/* Placeholder visible si la imagen no carga */}
              <div className="unilin-img-placeholder" style={{ display: 'none' }}>
                <i className="fa-solid fa-image"></i>
                <span>Imagen del sistema Unilin Click</span>
              </div>
            </div>
          </div>

          {/* Columna Imagen Unilin — derecha en desktop, abajo en móvil */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="unilin-content pe-lg-4 wow fadeInLeft" data-wow-delay="300ms">
              <div className="mb-3 title-style5">
                <h2 className="h1 font-weight-800 mb-0">
                  Sistema de Ensamblado<br />
                  <span className="unilin-brand-name">Unilin Click</span>
                </h2>
              </div>

              <p className="mb-4 opacity9 fs-18">
                El Piso SPC Premium incorpora el sistema de ensamblado <strong>Unilin Click</strong>,
                una tecnología de bloqueo patentada que une cada panel de forma segura y precisa,
                sin necesidad de pegamentos ni herramientas especiales.
              </p>

              <div className="unilin-benefits">
                <div className="benefit-item mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-bolt"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Instalación rápida y sencilla</h4>
                      <p className="mb-0 opacity7">
                        El sistema macho-hembra encaja con un clic audible —
                        sin adhesivos, sin esperas, listo para usar de inmediato.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="benefit-item mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-lock"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Unión firme sin huecos</h4>
                      <p className="mb-0 opacity7">
                        La pretensión del perfil Uniclic mantiene los tablones
                        perfectamente alineados, eliminando separaciones no deseadas.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="benefit-item mb-3">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-rotate-left"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Desmontable y reutilizable</h4>
                      <p className="mb-0 opacity7">
                        Permite retirar y reemplazar paneles individuales sin
                        remover toda la instalación, facilitando reparaciones.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="d-flex align-items-start">
                    <span className="benefit-icon me-3">
                      <i className="fa-solid fa-ruler-combined"></i>
                    </span>
                    <div>
                      <h4 className="mb-1">Compatible desde 3.2 mm</h4>
                      <p className="mb-0 opacity7">
                        Funciona en lados largos y cortos del panel,
                        compatible con materiales a partir de 3.2 mm de espesor.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <a href="contacto-decototal" className="butn-style7 rounded">
                  Obtén Más Información
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ReversoPisoSpcPremium;